import { Map } from 'immutable';
const resourceSelector = (state, props = {}) => state.getIn(['cache',`/${props.type}/${props.id}`], Map());
export default resourceSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/resourceSelector.js
 **/